import { createStore, Store } from 'vuex'
import axios from 'axios'
import { InjectionKey } from 'vue'

export interface State {
  status: 'auth' | 'loading' | 'anon'
  userId: number
  userName: string
  userEmail: string
  userAdmin: boolean
  userUtm: string
  routeLoading: boolean
  webinarURI: string
}

export const key: InjectionKey<Store<State>> = Symbol('store')

export const store = createStore<State>({
  strict: true,
  state: {
    status: 'loading',
    userId: 0,
    userName: '',
    userEmail: '',
    userUtm: '',
    userAdmin: false,
    routeLoading: false,
    webinarURI: '',
  },
  actions: {
    async checkAuth({ commit }) {
      commit('setStatusLoading')
      try {
        const { data } = await axios.get('/current_user')
        commit('setUserId', data.id)
        commit('setUserEmail', data.email)
        commit('setUserName', data.name)
        commit('setUserAdmin', data.admin)
        commit('setUserUtm', data.utm)
        commit('setStatusAuth')
      } catch (e) {
        commit('setStatusAnon')
      }
    },
  },
  mutations: {
    setStatusLoading: (state) => {
      state.status = 'loading'
    },
    setStatusAuth: (state) => {
      state.status = 'auth'
    },
    setStatusAnon: (state) => {
      state.status = 'anon'
    },
    setUserId: (state, id: number) => {
      state.userId = id
    },
    setUserName: (state, name: string) => {
      state.userName = name
    },
    setUserEmail: (state, email: string) => {
      state.userEmail = email
    },
    setUserAdmin: (state, admin = false) => {
      state.userAdmin = admin
    },
    setUserUtm: (state, utm = '') => {
      state.userUtm = utm
    },
    setRouteLoading: (state, loading = false) => {
      state.routeLoading = loading
    },
    setWebinarURI: (state, uri = '') => {
      state.webinarURI = uri
    },
  },
})
